export default __webpack_public_path__ + "static/media/minus.02db46f8.svg";